// frontend/src/components/Sidebar.js
import React from 'react';
import {
  Box, Toolbar, Typography, Divider, List, ListItem, ListItemButton,
  ListItemIcon, ListItemText, Avatar, Tooltip, IconButton
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import EventIcon from '@mui/icons-material/Event';
import LogoutIcon from '@mui/icons-material/Logout';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// Conteúdo do menu lateral. isCollapsed só vale para a versão fixa (desktop).
export default function Sidebar({
  isCollapsed,
  showCollapseToggle = false,
  user,
  menuItems,
  view,
  onSelect,
  onLogout,
  onToggleCollapsed
}) {
  return (
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <Toolbar
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            justifyContent: isCollapsed ? 'center' : 'flex-start',
            px: isCollapsed ? 1 : 2
          }}
        >
          <Avatar sx={{ bgcolor: 'primary.main', width: 32, height: 32 }}>
            <EventIcon fontSize="small" />
          </Avatar>
          {!isCollapsed && (
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle1" noWrap sx={{ lineHeight: 1.1 }}>
                Atendimentos
              </Typography>
              {user?.username && (
                <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
                  {user.username}
                </Typography>
              )}
            </Box>
          )}
        </Toolbar>
        <Divider />
        <List sx={{ flexGrow: 1, py: 1 }}>
          {menuItems.map(item => {
            const button = (
              <ListItemButton
                selected={view === item.key}
                onClick={() => onSelect(item.key)}
                disabled={item.auth === false}
                sx={{
                  justifyContent: isCollapsed ? 'center' : 'flex-start',
                  px: isCollapsed ? 1.5 : 2,
                  '&.Mui-selected': {
                    bgcolor: theme => alpha(theme.palette.primary.main, 0.12),
                    borderLeft: '3px solid',
                    borderColor: 'primary.main',
                    color: 'primary.main',
                    '&:hover': {
                      bgcolor: theme => alpha(theme.palette.primary.main, 0.18)
                    },
                    '& .MuiListItemIcon-root': { color: 'primary.main' }
                  }
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: isCollapsed ? 0 : 2,
                    justifyContent: 'center'
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                {!isCollapsed && <ListItemText primary={item.label} />}
              </ListItemButton>
            );
            return (
              <ListItem key={item.key} disablePadding sx={{ px: 0 }}>
                {isCollapsed ? (
                  <Tooltip title={item.label} placement="right">
                    <span style={{ width: '100%' }}>{button}</span>
                  </Tooltip>
                ) : (
                  button
                )}
              </ListItem>
            );
          })}
        </List>
        <Divider />
        <List sx={{ py: 1 }}>
          <ListItem disablePadding sx={{ px: 0 }}>
            {isCollapsed ? (
              <Tooltip title="Logout" placement="right">
                <span style={{ width: '100%' }}>
                  <ListItemButton onClick={onLogout} sx={{ justifyContent: 'center', px: 1.5 }}>
                    <ListItemIcon sx={{ minWidth: 0 }}>
                      <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                  </ListItemButton>
                </span>
              </Tooltip>
            ) : (
              <ListItemButton onClick={onLogout}>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <LogoutIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Logout" />
              </ListItemButton>
            )}
          </ListItem>
        </List>
        {showCollapseToggle && (
          <>
            <Divider />
            <Box sx={{ display: 'flex', justifyContent: isCollapsed ? 'center' : 'flex-end', p: 1 }}>
              <Tooltip title={isCollapsed ? 'Expandir menu' : 'Recolher menu'} placement="right">
                <IconButton size="small" onClick={onToggleCollapsed}>
                  {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
              </Tooltip>
            </Box>
          </>
        )}
      </Box>
  );
}
